import React, {Component} from "react";
import {Link, Redirect} from "react-router-dom";
import {Container, Row, Col, FormGroup, FormLabel, FormControl} from "react-bootstrap";
import Card from "../../../components/Cards/Card/Card";
import Button from "../../../components/Common/KnoaButton";
import {API} from "lib/API";
import Spinner from "../../../components/Common/Spinner";
import {withTranslation} from 'react-i18next';
import {clearNotifications} from "../../../lib/notifications/clearNotifications";
import {notifyWithMessage} from "../../../lib/notifications/notifyWithMessage";
const localStorage = require('../../../lib/localStorage');

class twoFactorAuthentication extends Component {
    constructor(props) {
        super(props);
        this.oneTimeCodeInput = null;
        this.submitRequest = this.submitRequest.bind(this);
        this.setOneTimeCodeInputRef = element => {
            this.oneTimeCodeInput = element;
        };
        this.state = {
            oneTimeToken: null,
            accessToken: (this.props.location.state && this.props.location.state.accessToken) ? this.props.location.state.accessToken : "",
            email: (this.props.location.state && this.props.location.state.email) ? this.props.location.state.email : null, //to be used
            password: (this.props.location.state && this.props.location.state.password) ? this.props.location.state.password : null, //to be used
            homeRedirect: false,
            fetchInProgress: "false"
        }
    }

    oneTimeCodeChange = (e) => {
        this.setState({
            oneTimeToken: e.target.value
        });
    };

    updateTokens = ({accessToken, expiresIn}) => {
        API.updateTimeout({expiresIn});
        this.setState({accessToken: accessToken});
    };

    submitRequest() {
        this.setState({fetchInProgress: "true"});
        API.clearBeat();
        let objAPI = {};
        objAPI.accessToken = this.state.accessToken;
        objAPI.oneTimeToken = this.state.oneTimeToken;

        console.log("the very first time accessToken " + objAPI.accessToken);
        console.log("one time token " + objAPI.oneTimeToken);
        API.user
            .post('/session/tfa', objAPI)
            .then(resp => {
                if (resp) {
                    const {data: resData} = resp;
                    const {data} = resData;
                    this.setState({
                        accessToken: data.access});
                    this.updateTokens({
                        accessToken: data.access,
                        expiresIn: data.expires
                    });
                    
                    this.setState({homeRedirect: true})
                }else {
                    clearNotifications();
                    notifyWithMessage({type: "error", t: this.props.t});
                }

                this.setState({fetchInProgress: localStorage.get("isLoading")});
            })
            .catch(e => {
                console.error(e);
                this.setState({homeRedirect: false,
                    fetchInProgress: localStorage.get("isLoading")});
                if(localStorage.get("accessDenied401")=== "true"){
                    window.location.href = "/#/auth/logout"
                    return;
                }
                
                if (e.data) {
                    clearNotifications();
                    let result = e.data.result;
                    if(result !== undefined || result !== null)
                        notifyWithMessage({type: "error", t: this.props.t, operation: result, parameter: null, resultCode: null});
                    else
                        notifyWithMessage({type: 'error', t: this.props.t, errorObject: e, isNormal: true});
                }
            });
    };

    submitForm = e => {
        e.preventDefault();
        this.submitRequest();
    };

    focusOneTimeCodeInput() {
        if (this.oneTimeCodeInput) this.oneTimeCodeInput.focus();
    }

    componentDidMount() {
        this.focusOneTimeCodeInput();
    }

    handleClick = () => {
        API.clearBeat();
        API.user
            .post('/session/login', {
                email: this.state.email,
                password: this.state.password
            })
            .then(resp => {
                if (resp) {
                    const {data: resData} = resp;
                    const {data} = resData;

                    this.setState({
                        accessToken: data.access});
                    this.updateTokens({
                        accessToken: data.access,
                        refreshToken: data.refresh,
                        expiresIn: data.expires
                    });

                    clearNotifications();
                    notifyWithMessage({type: "info", t: this.props.t, operation: "codeSentConfirmation", parameter: null});
                } else {
                    clearNotifications();
                    notifyWithMessage({type: "error", t: this.props.t, operation: "codeSentFailed", parameter: null, resultCode: null});
                }
            })
            .catch(e => {
                console.error(e);
                if(localStorage.get("accessDenied401")=== "true"){
                    window.location.href = "/#/auth/logout"
                    return;
                }
                clearNotifications();
         
                if(e.data.resultCode>-1)
                    notifyWithMessage({type: "error", t: this.props.t, resultCode: e.data.resultCode, isNormal: true});
                else
                    notifyWithMessage({type: "error", t: this.props.t, operation: "codeRequestFailed", parameter: null, resultCode: null});
            });
    };

    render() {
        if (this.state.homeRedirect) {
            return <Redirect to={{pathname: '/admin/home'}}/>
        }

        return (
            <Container>
                <Row>
                    <Col md={{ span: 4, offset: 4 }} sm={{ span: 6, offset: 3 }}>
                        <form onSubmit={this.submitForm}>
                                {this.state.fetchInProgress === "true" && <Spinner/>}
                                <div hidden={this.state.fetchInProgress === "true"}>
                    
                                                <Card
                                                    textCenter={true}
                                                    title={this.props.t('adminSettings:tfaConfirmCardTitle')}
                                                    content={
                                                        <div>
                                                            <span className='forgotPassInfo'>Check your email and enter the code below. If you did not receive a code or your code is expired, click the "Request New Code" link to request a new one.</span>
                                                            <FormGroup>
                                                                <FormLabel htmlFor="Code">{"Code"}</FormLabel>
                                                                        <FormControl
                                                                            name="Code"
                                                                            id="Code"
                                                                            value={this.state.oneTimeCode}
                                                                            placeholder={"Code"}
                                                                            type="text"
                                                                            autoComplete="off"
                                                                            ref={this.setOneTimeCodeInputRef}
                                                                            onChange={this.oneTimeCodeChange}
                                                                        />
                                                            </FormGroup>
                                                        </div>
                                                    }
                                                    legend={
                                                        <>
                                                            <Button
                                                                variant="info"
                                                                className='btn-fill'
                                                                type="submit">
                                                                Verify
                                                            </Button>
                                                            <br></br>
                                                            <Link className='loginLink' onClick={this.handleClick}>Request New Code</Link>
                                                        </>
                                                    }
                                                    ftTextCenter
                                                />
                                </div>
                        </form>
                    </Col>
                </Row>
            </Container>);
    }
}

export default withTranslation()(twoFactorAuthentication);